import { HugeiconsIcon } from "@hugeicons/react";
import { SquareLock01Icon } from "@hugeicons-pro/core-stroke-rounded";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";

export const PermittedContent = ({
  children,
  isPermitted,
  protectedIconSize = 20
}: {
  isPermitted: boolean;
  protectedIconSize?: number;
  children: React.ReactNode;
}) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment -- that's fine and expected
  <>
    {isPermitted ? (
      children
    ) : (
      <Tooltip>
        <TooltipTrigger as="div" className="cursor-pointer text-left">
          <HugeiconsIcon
            icon={SquareLock01Icon}
            size={protectedIconSize}
            className="text-content-100"
          />
        </TooltipTrigger>

        <TooltipContent className="max-w-[340px] rounded-lg z-[50] border bg-alpha-800 p-4 text-sm text-content-1000-inverted shadow-xs">
          You don’t have permission to view this data. Please contact your
          administrator if you believe this is an error
        </TooltipContent>
      </Tooltip>
    )}
  </>
);
